import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import getLandingPageData from 'store/landing/selector/getLandingPageData';
import { LandingPageProvider } from 'context/LandingPageContext';
import isDesktop from 'store/app/selector/isDesktop';
import LandingPageBuilder from 'components/LandingPage/Factory/LandingPageBuilder';
import fetchNoResultsContentOperation from 'store/search/operation/fetchNoResultsContentOperation';
import styles from './NoFavourites.module.scss';

const NoFavourites = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const landingPageData = useSelector(getLandingPageData);
  const isDesktopDevice = useSelector(isDesktop);
  const headingTextVariant = isDesktopDevice ? 'headline-medium-regular' : 'body-large-bold';
  const subheadingVariant = isDesktopDevice ? 'body-large-light' : 'body-medium-regular';

  useEffect(() => {
    dispatch(fetchNoResultsContentOperation());
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.headline}>
        <OpText variant={headingTextVariant} className={styles.heading}>
          {t('txt_no_favourites_heading')}
        </OpText>
        <OpText block variant={subheadingVariant} className={styles.subheading}>
          {t('txt_no_favourites_details')}
        </OpText>
      </div>
      <div className={styles.lpContainer}>
        {landingPageData && landingPageData.content && (
          <LandingPageProvider>
            <LandingPageBuilder landingPageData={landingPageData} />
          </LandingPageProvider>
        )}
      </div>
    </div>
  );
};

export default NoFavourites;
